import React, { useState, useMemo } from "react";
import { Button, Form, Input, Modal } from "antd";
import { lib } from "react-single-app";

const FormItem = Form.Item;

export function Check({ status = false, children, style = {} }) {
    return (
        <div className={`check ${status}`} style={style}>
            {children}
        </div>
    );
}

export default function PwModal({ pwVisible, onClose }) {
    let [password, setPassword] = useState("");
    let [form] = Form.useForm();

    function onOk() {
        form.validateFields()
            .then(values => {
                lib.request({
                    url: "/ucenter-account/current/updatePwd",
                    data: {
                        oldPassword: values.oldPassword,
                        password: values.password,
                    },
                    needMask: true,
                    success: res => {
                        onClose(true);
                        setPassword("");
                        form.resetFields();
                    },
                });
            })
            .catch(e => {});
    }

    const passwordTooltip = useMemo(
        () => () => {
            return (
                <>
                    <Check
                        style={{ marginTop: "10px" }}
                        status={(() => {
                            return password.length > 7 && password.length < 21;
                        })()}>
                        密码长度为8-20位
                    </Check>
                    <Check
                        status={(function () {
                            return /^([\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F]|\w)+$/.test(password);
                        })()}>
                        只能包含大小写字母、数字以及英文符号（不含空格）
                    </Check>
                    <Check
                        style={{ marginBottom: "10px" }}
                        status={(function () {
                            return (
                                /[\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F]+/.test(password) +
                                    /\d+/.test(password) +
                                    /[a-z]+/.test(password) +
                                    /[A-Z]+/.test(password) >
                                2
                            );
                        })()}>
                        大写字母、小写字母、数字和英文符号至少包含3种
                    </Check>
                </>
            );
        },
        [password],
    );
    return (
        <Modal
            title="修改密码"
            visible={pwVisible}
            onOk={() => onOk()}
            onCancel={() => {
                setPassword("");
                form.resetFields();
                onClose();
            }}>
            <Form
                form={form}
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 16 }}
                onValuesChange={(changedValues, values) => {
                    if (changedValues.hasOwnProperty("password")) {
                        setPassword(changedValues?.password);
                    }
                }}>
                <FormItem label="旧密码" name="oldPassword" rules={[{ required: true }]}>
                    <Input type="password" autoComplete={"new-password"} />
                </FormItem>
                <FormItem
                    label="新密码"
                    name="password"
                    rules={[
                        { required: true },
                        {
                            validator: (rule, value) => {
                                return new Promise((resolve, reject) => {
                                    if (
                                        !/^([\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F]|\w){8,20}$/.test(
                                            value,
                                        ) ||
                                        /[\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F]+/.test(value) +
                                            /\d+/.test(value) +
                                            /[a-z]+/.test(value) +
                                            /[A-Z]+/.test(value) <
                                            3
                                    ) {
                                        reject();
                                    } else {
                                        resolve();
                                    }
                                });
                            },
                            validateTrigger: "onSubmit",
                        },
                    ]}
                    help={passwordTooltip()}>
                    <Input type="password" maxLength={20} />
                </FormItem>

                <FormItem
                    label="确认密码"
                    name="password2"
                    rules={[
                        {
                            required: true,
                            message: "请输入确认密码",
                        },
                        ({ getFieldValue }) => ({
                            validator(rule, value) {
                                if (!value || getFieldValue("password") === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject("两次输入密码不相同");
                            },
                        }),
                    ]}>
                    <Input type="password" />
                </FormItem>
            </Form>
        </Modal>
    );
}
